export const approvalStatus = {
    approve: 1,
    reject: 2
};
